import { render, staticRenderFns } from "./VMultipleChoice.vue?vue&type=template&id=330fcef3&"
import script from "./VMultipleChoice.vue?vue&type=script&lang=ts&"
export * from "./VMultipleChoice.vue?vue&type=script&lang=ts&"
import style0 from "./VMultipleChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports